import { createSlice } from '@reduxjs/toolkit';

import type { RootState } from '../store';

const initialState = {
  pagination: {
    totalPages: 0,
    currentPage: 0,
    size: 10,
    sorting: undefined,
  },
};

export const tableConfigSlice = createSlice({
  name: 'statutes',
  initialState,
  reducers: {
    setTablePagination(state, action) {
      state.pagination.totalPages = action.payload;
    },
    setTableCurrentPage(state, action) {
      state.pagination.currentPage = action.payload;
    },
    setTableSize(state, action) {
      state.pagination.size = action.payload;
    },
    setTableSorting(state, action) {
      state.pagination.sorting = action.payload;
    },
  },
});

export const getTotalPages = (rootState: RootState) =>
  rootState.tableConfig.pagination.totalPages;
export const getCurrentPage = (rootState: RootState) =>
  rootState.tableConfig.pagination.currentPage;
export const getSize = (rootState: RootState) => rootState.tableConfig.pagination.size;
export const getSorting = (rootState: RootState) => rootState.tableConfig.pagination.sorting;

export const { setTablePagination, setTableCurrentPage, setTableSize, setTableSorting } =
  tableConfigSlice.actions;
